export default "__VITE_ASSET__DrFduDwK__"